<template>
    <div>
        <public-title>房态日历</public-title>
        <div class="radio-group">
            <el-radio-group v-model="activeName" size="medium" @input="handleClick">
                <el-radio-button label="1">余房</el-radio-button>
                <el-radio-button label="2">已订</el-radio-button>
                <el-radio-button label="3">待接团队<span v-if="IndexData.order_arr.confirm_doing_self_handle > 0"  :style="activeName==3?'color: #fff;': 'color: #999;'">丨<span :style="activeName==3?'color: #fff;font-weight: bold;': 'color: red; font-weight: bold;'">{{IndexData.order_arr.confirm_doing_self_handle}}</span></span    ></el-radio-button>
            </el-radio-group>
            <div class="select" v-if="activeName!='3'">
                <div class="select-i" @click="prevMonth">
                    <i class="el-icon-arrow-left" :style="roomType==0?'color:#ccc':''"></i>
                </div>
                <el-select v-model="roomType" placeholder="请选择" size="small"  >
                    <el-option v-for="item in monthTimestamps" :key="item.id" :label="item.title" :value="item.id" />
                </el-select>
                <div class="select-i" @click="nextMonth">
                    <i class="el-icon-arrow-right" :style="roomType==monthTimestamps.length-1?'color:#ccc':''"></i>
                </div>
            </div>
        </div>
        <div class="load-area-calendar">
            <div class="calendar" >
                <template v-if="activeName<3">
                    <div class="roomalender">
                        <div  v-for="item in weekDays" class=" leite" :class="{'weekend':item === '星期六' || item === '星期日'}" :key="item">{{item}}</div>
                    </div>
                    <div class="roomalender lender ">
                        <template > 
                            <div class=" calender grey" v-for="(item,index) in week-1" :key="index"></div>
                        </template>
                        <!--单独一项-->
                        <template v-for="item in Monthtiem">
                            <div class=" calender tiem-grey" :class="{'past':item.past}" :key="item.select_time" v-if="activeName != 0" @click="teamList(item)">
                                <div class="tiem " >
                                    <div class="form-item">
                                        <p>{{item.title}}</p><span>{{item.lunar}}</span>
                                        <div  class="today-identifier" v-if="(timeday/1000) == item.select_time">今 天</div>
                                    </div>
                                </div>
                                <div class="form-label" v-if="(item.s_num1 >0||item.s_num2> 0)&&activeName == 1">
                                    <!-- <div class="form-team_num"><p @click="TeamList(item)" :class="{'cursor_pointer calenders':item.team_num>0}">{{item.team_num||0}}</p><span>预订团数 </span></div> -->
                                    <div class="form-name" v-if="!item.past">
                                        <div><i>余量</i></div>
                                        <div><p>{{item.s_num1+item.s_num2||0}}</p><i>间</i></div>
                                    </div>  
                                </div>
                                <div class="form-label" v-if="activeName == 2"> 
                                    <div class="form-name gered " v-if="item.teamConfirmation>0">
                                        <div><i>待确认</i><p>{{item.teamConfirmation}}</p><i>团 </i></div>
                                    </div>
                                    <div class="form-name orange" v-else-if="item.b_num1 >0||item.b_num2> 0">
                                        <div><i>已订</i><p>{{item.b_num1+item.b_num2||0}}</p><i>间</i></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <!-- <div class="text-left mt-4">
                        <div class="yfe">
                            <el-button class="but" @click="selectTiem('minus')" type="primary" size="small" v-if="roomType!='0'" >上一月</el-button>
                            <el-button class="but" @click="selectTiem('add')" type="primary" size="small" v-if="roomType!=monthTimestamps.length">下一月</el-button>
                        </div>
                    </div> -->
                </template>
                <template v-if="activeName==3">
                    <ConfirmList :roomStatus="true" style="margin-top: -16px;"></ConfirmList>
                </template>
            </div>
            <!--房态总览-->
            <div class="room-overview">
                <div class="overview-item">
                    <div class="title">房态总览<span>( 全部房型 )</span></div>
                    <div class="ringTpey">
                        <!--环形图-->
                        <Ring class="ring" :ringTpey="ringTpey"></Ring>
                        <ul class="ringTpey-list">
                            <li class="ringTpey-item" v-for="(item,index) in ringTpey" :key="item.name">
                                <i :style="'background-color: '+item.color"></i>
                                <p class="ringTpey-item-name">{{item.name}}</p>
                                <p class="ringTpey-item-value">{{item.value}}<span>{{index==2?'团':'间'}}</span></p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="overview-item today">
                    <div class="title">今日概览<span>( {{ todayTimestamp| formatTimestamp(8) }} )</span></div>
                    <div class="ringTpey">
                        <ul class="ringTpey-list">
                            <li class="ringTpey-item" v-for="(item,index) in ringTpey" :key="item.name">
                                <!-- <i :style="'background-color: '+item.color"></i> -->
                                <p class="ringTpey-item-name">{{item.name||0}}</p>
                                <p class="ringTpey-item-value" >{{item.todayValue||0}}<span>{{index==2?'团':'间'}}</span></p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="mt-3" v-if="!isGroup">
                    <el-button type="primary"  @click="centerDialogVisible=true" style="width: 100%;" icon="el-icon-date">修改余量</el-button>
                    <el-button   @click="publishConfirm" style="width: 100%; margin-left:0;" class="mt-3" icon="el-icon-edit-outline">发布订单确认</el-button>
                </div>
            </div>
            <el-dialog
                title="修改余量"
                :visible.sync="centerDialogVisible"
                :close-on-click-modal="false"
                width="460px"
                top="34vh"
                center>
                <AddRoom @switchsoto="switchsoto" :changetime="changetime" v-if="centerDialogVisible" :store_id="store_id" ></AddRoom>
            </el-dialog>
            <!-- <el-dialog
                title="预订团"
                :visible.sync="cliquenumber"
                :close-on-click-modal="false"
                width="1200px"
                center>
                <TeamList :select_time="select_time" :store_id="store_id" v-if="cliquenumber"></TeamList>
            </el-dialog>     -->
        </div>
        <TeamList :select_time="select_time" :store_id="store_id" @modifyaddRoom="modifyaddRoom" :cliquenumber="cliquenumber" @closeDrawer="cliquenumber=false"></TeamList>
        </div>
</template>
<script>
import {mapGetters,mapActions,mapState,mapMutations} from 'vuex'
import ConfirmList from '@/views/Order/ConfirmList/index'
import AddRoom from './AddRoom'
import TeamList from './components/TeamList'
import Ring from './components/ring.vue'          //环形图
import { Solar } from 'lunar-javascript'          //农历转换
var dayjs = require('dayjs')
export default {
    name: 'RoomCalendar',
    components:{ AddRoom,TeamList,Ring,ConfirmList},
    data() {
        return {
            centerDialogVisible:false,
            ringData:{
                total:156,                                                     //总间数
                booked:100,                                                    //已订间数
                team:50,                                                       //待接团队数
            },                                                                 //环形图数据 
            ringTpey:[
                {
                    name:'余房',
                    value:0,
                    color:'#1890FF',
                    todayValue:0, 
                    labelShow:false
                },
                {
                    name:'已订',
                    value:0,
                    color:'#00cea7',
                    todayValue:0, 
                    labelShow:false
                },
                {
                    name:'待接团队',
                    value:0,
                    color:'#fb983a',
                    todayValue:0,
                    labelShow:false
                },
            ],                                                                               //环形图数据2
            weekDays:['周一','周二','周三','周四','周五','周六','周日'],
            calender:[],
            monthTimestamps:[],                                                             //月份列表
            roomType:'3',                                                                   //当前月份
            Monthtiem:[],                                                                   //月份日期列表
            changetime:{},                                                                  //修改余量时间
            week:0,                                                                         //当月第一天星期几
            cycleTiem:[],                                                                   //当月31天日期
            timeday:0,                                                                      //当天时间戳
            cliquenumber:false,                                                              //预订团展示
            select_time:{},                                                                   //点击时间戳值
            activeName: '1',
            todayTimestamp:0,                                                                //今日时间戳
            
        }
    },
    computed: {
      ...mapState(['StoreRoomArr','StoreCalendar','userLoginMessage','IndexData']),
      ...mapGetters(['userInfo','storeInfo','isGroup']),
      //路由中的酒店ID，存在时判断为集团酒店获取日历
      store_id() { return this.$route.query.store||this.storeInfo.storeId},
    },
    created() {
      //获取房间列表
      this.getMonthTimestamps();
    },
    watch: {
        roomType(){
            this.timeMonth();
        }
    },
    methods: {
        ...mapMutations(['UPDATECONFIRMINFO',]),
        ...mapActions(['getStoreCalendar','HotelsRoomCalendarList']),
        //发布确认单
    publishConfirm(){
      this.UPDATECONFIRMINFO(this.storeInfo.storeId)
      let query = {orderConfirm:true,modify:true,orderConfirmSend:true}
      this.$router.push({name:'OrderPost',query})
    },
    /*添加房型*/
      goAddRoom() {
        let query = {step:'3',storeId:this.$route.query.storeId,GST:this.$route.query.GST}
        this.$router.replace({name:'RoomMeetManage',query})
      },
        getMonthTimestamps() {
            const timestamps = [];
            let roomType=[];
             // 复制当前日期，避免修改原始日期
            const currentDate = new Date();
            for(let i = 3; i >=1; i--){
                const targetDate = new Date(currentDate);
                // 设置月份，自动处理跨年情况
                targetDate.setMonth(currentDate.getMonth() - i);
                console.log(targetDate);
                // 设置为当月第一天
                targetDate.setDate(1);
                // 设置时间为00:00:00
                targetDate.setHours(0, 0, 0, 0);
                // 获取时间戳（毫秒）
                timestamps.push(targetDate.getTime());
            }
            // 获取当前月份和往后6个月的时间戳
            for (let i = 0; i < 6; i++) {
                const targetDate = new Date(currentDate);
                // 设置月份，自动处理跨年情况
                targetDate.setMonth(currentDate.getMonth() + i);
                // 设置为当月第一天
                targetDate.setDate(1);
                // 设置时间为00:00:00
                targetDate.setHours(0, 0, 0, 0);
                // 获取时间戳（毫秒）
                timestamps.push(targetDate.getTime());
            }
            for(let i in timestamps){
                roomType.push({id:i,title:this.formatDate(timestamps[i]),tiem:timestamps[i]/1000})
            }
            this.monthTimestamps = roomType;

            this.timeMonth();
        },
        //时间戳转日期
        formatDate(timestamp,i=0) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            // 获取月份并补零
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const sun = String(date.getDate());
            if(i==0){
                return `${year}年${month}月`;
            }if(i==1){
                return `${sun}`;
            }
        },
        //循环当月每天0点时间戳
        timeMonth(){
            let roomType=this.monthTimestamps[this.roomType*1],Monthtiem=[];
            // 今日零点毫秒戳
            const todayZeroMs = dayjs().startOf('day').valueOf();
            //传月份时间戳判断当月有多少天
            let date = new Date(roomType.tiem*1000);
            const year = date.getFullYear();
            const month = date.getMonth();
            let n= new Date(year, month + 1, 0).getDate();
            //循环当月每天0点时间戳生成月份日期
            for(let i=1;i<=n;i++){
                let time=new Date(year, month, i, 0, 0, 0, 0).getTime();
               const date = new Date(time)
                const y = date.getFullYear()
                const m = date.getMonth() + 1 // 月份 1‑12
                const d = date.getDate()    
                // 创建公历对象
                const solar = Solar.fromYmd(y, m, d)
                // 转农历
                const lunar = solar.getLunar()
                Monthtiem.push({select_time:time/1000,title:this.formatDate(time,1),past:time<todayZeroMs?true:false,lunar:lunar.toString().slice(-2),festival:lunar.getFestivals()})
            }
            this.todayTimestamp=todayZeroMs;
            this.cycleTiem=Monthtiem;
            this.PsotHotelsRoomCalendarList();
        },
        //获取房态列表（默认传当月时间戳）
        async PsotHotelsRoomCalendarList(){
            let roomType=this.monthTimestamps[this.roomType*1];
            let Monthtiem=this.cycleTiem;
            let date = new Date(roomType.tiem*1000);
            //n为天数
            const week=date.getDay();
            let data={
                store_id:this.store_id,
                month_time:roomType.tiem
            }
            console.log(week);
            this.week=week==0?7:week;
            //获取当天时间戳
            const currentDate = new Date();
            // 设置时间为00:00:00
            currentDate.setHours(0, 0, 0, 0);
            // 获取时间戳（毫秒）
            this.timeday=currentDate.getTime();
            this.HotelsRoomCalendarList({
                data,
                successFun:(res)=>{

                    console.log(sumAll);
                    Monthtiem.forEach((item,index)=>{
                        res.list.forEach(room=>{
                            if(room.select_time==item.select_time){
                                Monthtiem[index]={
                                    ...item,
                                    ...room,
                                }
                            }
                        })
                        if(res.confirm_handle){
                            res.confirm_handle.forEach(room=>{
                                const keys = Object.keys(room)[0];
                                if(keys==item.select_time){
                                    Monthtiem[index]={
                                        ...item,
                                        teamConfirmation:room[keys]
                                    }
                                }
                            })
                        }
                    })
                   //全部总和：计算余房数量
                    let sumAll = res.list.reduce((total,item)=>{
                        return total + item.s_num1 + item.s_num2
                    },0)
                    //全部总和：计算余房数量
                    let sumRoom = res.list.reduce((total,item)=>{
                        return total + item.b_num1 + item.b_num2
                    },0)
                    this.ringTpey[0].value=sumAll;
                    this.ringTpey[1].value=sumRoom;
                    this.ringTpey[2].value=res.confirm_handle.length;
                    this.calender=res.list;
                    this.Monthtiem=[...Monthtiem];
                    //获取当天数据
                    this.getTodayData();
                }
            });

        },
        //获取当天数据
        getTodayData(){
            let item=this.Monthtiem.find(room=>room.select_time==this.todayTimestamp/1000);
            if(item){
                this.ringTpey[0].todayValue=item.s_num1 + item.s_num2;
                this.ringTpey[1].todayValue=item.b_num1 + item.b_num2;
                this.ringTpey[2].todayValue=item.teamConfirmation?item.teamConfirmation.length:0;
            }
        },
        //点击一项修改房态
        modifyaddRoom(item){
              this.centerDialogVisible=true;
                this.changetime=item;
        },
        switchsoto(ruleForm){
            console.log(ruleForm);
            this.centerDialogVisible=false;
            this.select_time={...this.select_time,...ruleForm}
            this.PsotHotelsRoomCalendarList()
        },
        selectTiem(e){
            let roomType
            if(e=='add'){
                roomType=this.roomType*1+1;
            }else{
                roomType=this.roomType*1-1;
            }
            this.roomType=roomType.toString();
        },
        //开启预订团
        teamList(item){
            this.cliquenumber=true;
            this.select_time=item;
            // if(item.team_num>0){
            // }
        },
        //切换显示模式
        handleClick(tab, event){
            console.log(tab, event);
        },
        //切换最小日期
        prevMonth(){
            if(this.roomType!=0){
                this.roomType=`${this.roomType*1-1}`;
            }
            
        },
        //切换最大日期
        nextMonth(){
            if(this.monthTimestamps.length-1!=this.roomType){
                this.roomType=`${this.roomType*1+1}`;
            }
            
        },
    }
}
</script>
<style lang="scss" scoped>
    .radio-group{
        text-align: left;
        margin-bottom: 20px;
        width: 75%;
        display: flex;
        justify-content:space-between;
    }
    .select{
        display: flex;
        .select-i{
            background-color: #fff;
            box-shadow: 0px 0px 7px #eee;
            height: 32px;
            width: 32px;
            text-align: center;
            line-height: 32px;  
        }
    }
    .calendar{
        width: 75%;
        box-shadow: 0px 0px 7px #eee;
        border-radius: 4px;
        overflow: hidden;  
    }
    .load-area-calendar{
        // border: 1px #E4E7ED solid;
        overflow: auto;
        display: flex;
        justify-content:space-between;
    }
    .shqColor{
        color: #fb983a !important;
        font-weight: bold;
    }
    .greyColor{
        color: #999;
    }
    .calenders{
        color: var(--smtc-color-primary) !important;
        font-weight: bold;
    }
  .cursor_pointer{
    cursor: pointer;
  }
  .roomalender{
    display: flex;
    justify-content: left;
    border-collapse: collapse;
    background-color: #fff;
    width: 100%;    
    .leite{
        width: 15%;
        height: 40px;
        color: #333;
        line-height: 40px;
        border-right: 1px #eee solid;  
        font-weight: bold;
    }
    .weekend{
         color: var(--smtc-color-primary);
    }
    .calender{
        border-right: 1px #f0f0f0 solid;
        padding: 12px 0;
        position: relative;
        overflow: hidden;
        display: flex;
        justify-content: center;
        flex-direction: column;
        height: 126px;
        .tiem{
            font-size: 20px;
            float: left;
            width: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            position: relative;
            z-index: 3;
            padding: 10px 0;
            >p{
                font-family: '黑体';
                text-align:left;
            }
            >span{
                font-size: 12px;
     
                margin-top: 6px;
            }
        }
        .name{
            line-height: 35px;
            margin-right: 10px;
            position: relative;
            z-index: 9;
        }
        .Internal{
            float: right;
            width: 52%;
            border-left: 1px #999 solid;
            display: flex;
            position: relative;
            z-index: 3;
            div{
                width: 50%;
            }
            span{
                width: 100%;
                text-align: center;
                display: block;
                float: left;
                line-height: 35px;
            }
        } 
    }
  }
    .lender{
        flex-wrap:wrap;
        justify-content:left;
        .calender{
            width: calc((100% - 6 * 1px) / 7);
            border-bottom: 1px #f0f0f0 solid;
        }
    }
    .yfe{
        width: 100%;
        display: flex;
        justify-content: center;
        
    }
    .smallsq{
        float: right;
        margin-right: 10px;
    }
    .grey{
        background-color: #fafafa;
    }
    .currently{
        width: 69%;
        float: left;
        background-color: #f5f5f5;
        height: 160px;
        text-align: center;
        line-height: 156px;

        position: absolute;
        top: 1px;
        right: 1px;
        z-index: 1;
    }

    .fudtitle{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        color: #eee;
        height: 100%;
        font-size: 80px;
        font-weight: bold;
        text-align: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .but{
        width: 160px;
    }
    .activeName  {
        background-color: #fff;
        float: left;
    }
    .activ{
        overflow: hidden;
    }
    .form-label{
        width: 100%;
        overflow: hidden;
    }
    .roomalender .calender .form-item{
        display: flex;
        justify-content: left;
        width: 90%;
        margin-left: 10%;
        span{
            font-size: 12px;
            color: #999;
            margin-top: 9px;
            margin-left: 6px;
        }
    }
    .roomalender .calender .form-item p{
        font-size: 26px;
        font-weight: bold;
        font-family: '黑体';
        color: #333;
    }
    .form-team_num{
            width: 94%;
            margin: 0 auto;
            margin-bottom: 6px;
        p{
            font-size: 24px;

            color: #999;
        }
        span{
            color: #999;
            font-size: 14px;
        }
    }
    .form-name{
        width: 92%;
        text-align:left;
        div{
            padding: 0 10%;
            border-radius: 4px;
            line-height: 26px;
            i{
                color: #999;
                font-style: normal;
                font-size: 14px;
            }
            p{
                font-size: 20px;
                color:var(--smtc-color-primary);
                font-family: '黑体';
                font-weight: bold;
                // i{
                //     font-weight: normal;
                //     margin-left: 2px;
                //     margin-top: -1px;
                // }
            }
            span{
                font-size: 12px;
                font-weight: normal;
                color: #999;
            }
            .shqColor{
                color: #fb983a !important;
                font-weight: bold;
            }
        }
        .redColor{
            background-color: var(--smtc-color-primary);
            i,p{
                color: #fff ;
            }
        }
    }
    .tiem-grey{
        cursor: pointer;
    }
    .past{
        background-color: #fafafa;
        .form-item p{
            color: #ccc !important;
        }
    }
    .orange p{
        color: #00cea7!important;
    }
    .gered p{
        color: #fb983a  !important;
    }
    .room-overview{
        width: 23%;  
    }
    .overview-item{
        text-align: left;
        width: 92%;
        padding: 12px 4%;
        background-color: #fff;
        box-shadow: 0px 0px 7px #eee;
        border-radius: 4px;
        .title{
            font-size: 14px;
            font-weight: bold;
            color: #333;
            span{

                font-weight: normal;
                color: #999;
                margin-left: 6px;
            }
        }
    }
    .ring{
        margin-left: -30px;
    }
    .ringTpey{
        display: flex;
        justify-content:space-between;
    }
    .ringTpey-list{
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 55%;
        li{
            display: flex;
            margin-top: 20px;
            width: 100%;
            i{
                width: 14px;
                height: 14px;
                border-radius: 50%;
                background-color: var(--smtc-color-primary);
                margin-right: 4px;
                margin-top: 3px;
            }
        }

    }
    .ringTpey-list li:nth-child(1){
        margin-top: 0;
    }
    .ringTpey-item-value{
        margin-left: auto;
        font-size: 14px;
        font-weight: normal;
        color: #999;
    }
    .today{
        margin-top: 20px;
        .ringTpey-list {
            width: 100%;
            margin: 20px 0;
        }
    }
    .today-identifier{
        background-color: var(--smtc-color-primary);
        font-size: 12px;
        font-weight: bold;
        color: #fff;
        line-height: 24px;
        height: 24px;
        width: 50px;
        margin-top: 5px;
        margin-left:12px;
        border-radius: 6px;
    }
</style>
<style>
    .select .el-select--small{
        margin: 0 10px;
        width: 140px;
    }
    .select .el-input__inner{
        border:initial;
        box-shadow: 0px 0px 7px #eee;
        font-weight: bold;
    }
</style>
